// extracted by mini-css-extract-plugin
export default {"reportManagement":"ReportManagement_reportManagement__ZAOKE","contentTitle":"ReportManagement_contentTitle__70PXs"};